import { Box, Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import LoginIcon from "@mui/icons-material/Login";

export function LogoutInfo() {
  const { t } = useTranslation();

  return (
    <Grid container justifyContent="center">
      <Box sx={{ mt: 10 }} textAlign="center">
        <Typography variant="h2">{t("logout.logout")}</Typography>
        <Typography textAlign="center">{t("logout.login")}</Typography>
        <Link to="/login">
          <Button sx={{ mt: 5 }} variant="contained" endIcon={<LoginIcon />}>
            {t("login")}
          </Button>
        </Link>
      </Box>
    </Grid>
  );
}
